import {
  Grid,
  Box,
  Typography,
  IconButton,
  Button,
  Avatar,
  StepConnector,
  Stepper,
  Step,
  StepLabel,
  Card,
  Paper,
} from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import {
  AirportShuttleOutlined,
  PhoneOutlined,
  KeyboardArrowDown,
} from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import back from "../../assets/images/svg/back.svg";
import star from "../../assets/images/svg/star.svg";
import starOutline from "../../assets/images/svg/starOutline.svg";
import truck from "../../assets/images/svg/truck.svg";
import logo from "../../assets/images/logo.png";
import reload from "../../assets/images/svg/reload.svg";
import add from "../../assets/images/svg/add.svg";
import info from "../../assets/images/svg/info.svg";
import driver from "../../assets/images/svg/driver.svg";
import reviewRed from "../../assets/images/svg/reviewRed.svg";
import reject from "../../assets/images/svg/reject.svg";
import success from "../../assets/images/svg/success.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { ImagePreview, ImageUploader } from "../../components";
import MapComponent from "../../components/maps/MapComponent";
import tick from "../../assets/images/tickNew.png";
import extratipicon from "../../assets/images/extra-icon.png";
import deliveredicon from "../../assets/images/delivered-icon.png";
import downloadicon from "../../assets/images/svg/download.svg";
import { $crud } from "../../utils/CrudFactory";
import PickupMap from "../../components/maps/PickupMap";
import dayjs from "dayjs";
import moment from "moment";
import { toLocalTime } from "../../helper/functions";
import PickupProofModal from "../../components/modals/PickupProofModal";

const displyStatus = {
  Reject: "Order Rejected",
  Review: "Order kept on Review",
};

const orderStatusIcon = {
  "Order Booked": add,
  "Driver Matched": driver,
  "Order Completed": success,
  Reject: reject,
  Review: reviewRed,
  "Order Reinstated": reload,
  Cancelled: reject,
  "Order Delivered": deliveredicon,
  "Extra Tip OB": extratipicon,
};

// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------
const CustomStepConnector = () => (
  <StepConnector
    sx={{
      "& .MuiStepConnector-line": {
        display: "block",
        borderColor: "#683C8C",
        borderLeftStyle: "dashed",
        borderLeftWidth: "1px",
        minHeight: "24px",
      },
    }}
  />
);
// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------

// CUSTOM TOOLTIP ====================================
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    minWidth: 140, // Custom maxWidth for Tooltip
    minHeight: 56, // Custom maxWidth for Tooltip
    background: "#795898", // Additional styles if needed
    color: "#fff", // Additional styles if needed
    fontSize: "8px", // Additional styles if needed
    padding: "8px", // Additional styles if needed
    position: "absolute",
    top: "-38px",
    left: "-90px",
    borderRadius: "0",
  },
});

// STEPS FOR THE STATUS OF ORDER -------------------------------
const steps = [];
// STEPS FOR THE STATUS OF ORDER -------------------------------
export default function PickUpDetails() {
  const [mergedSteps, setMergedSteps] = useState([]);
  const [client, setClient] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const [pickup, setPickup] = useState(location.state?.pickup || {});
  const [order, setOrder] = useState(location.state?.selectedOrder || {});
  async function retrieveClientDetails() {
    const { data } = await $crud.retrieve("admin/client", {
      customerID: order.customerId,
    });
    return data;
  }

  useEffect(() => {
    retrieveClientDetails().then((res) => {
      setClient(res);
    });
  }, [order]);

  useEffect(() => {
    // Combine order.positionHistory with existing steps
    const merged = [...steps];
    if (order && order.orderHistory) {
      order.orderHistory.forEach((historyItem, index, orderHistory) => {
        const diffMs =
          new Date(historyItem.timestamp).getTime() -
          new Date(orderHistory[index - 1]?.timestamp).getTime();
        const duration = moment.duration(diffMs);

        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();

        const display =
          index === 0
            ? ""
            : `${
                days < 1 ? "" : days < 2 ? `${days} day` : `${days} days`
              } ${hours} hr${hours !== 1 ? "s" : ""} ${minutes} min${
                minutes !== 1 ? "s" : ""
              }`;

        let label = historyItem.status;
        let desc = `${dayjs(historyItem.timestamp).format(
          "ddd,DD MMM YYYY, h:mm A"
        )} ${display}`;
        const iconimage = Object.keys(orderStatusIcon).find((val) =>
          historyItem.status.includes(val)
        );
        let icon = (
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {!/Working/i.test(historyItem.status) && (
              <img src={tick} alt="tick" style={{}} />
            )}
            <img src={orderStatusIcon[iconimage] || truck} alt="orderstatus" />
          </div>
        );

        merged.push({
          label,
          description: desc,
          icon,
          reason: historyItem.reason,
          tooltip: true,
          timestamp: historyItem.timestamp,
        });
      });
    }

    const sorted = merged.sort(
      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    );
    setMergedSteps(sorted);
  }, [order, steps]);

  const handleBackClick = () => {
    navigate(-1);
  };


  const calculateWaitingTime = (dateBooked) => {
    const bookedDate = new Date(dateBooked);
    const now = new Date();
    const diffMs = now - bookedDate; // Difference in milliseconds
    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60)); // Convert milliseconds to hours
    const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60)); // Remaining minutes

    return `${diffHrs} Hr ${diffMins} Min`;
  };

  const waitingTime = calculateWaitingTime(order.dateBooked);
  return (
    <Grid container sx={{ padding: "0 24px" }} spacing={1}>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "flex-start",
            gap: 1,
          }}
        >
          <IconButton onClick={handleBackClick} sx={{ marginLeft: "-10px" }}>
            <img src={back} />
          </IconButton>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: 6,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "5px",
                  color: "#673C8E", // Return the value directly
                }}
              >
                Pickup ID / {order.orderId}-{pickup.puDoId}
              </Typography>
              <img src={order.is_vip ? star : starOutline} />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                color: "#673C8E", // Return the value directly
              }}
            >
              Order ID {order.orderId}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} sx={{ textAlign: "right" }}>
        {/* <Box > */}
        <Typography
          variant="h5"
          sx={{
            fontSize: "13px",
            color: "#673C8E", // Return the value directly
          }}
        >
          Booked : {toLocalTime(order.dateBooked, "DD MMM YYYY - h:mm A")}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontSize: "11px",
            color: "#673C8E", // Return the value directly
            marginTop: "4px",
          }}
        >
          Booked Location : {order.bLocation}
        </Typography>
        {/* </Box> */}
      </Grid>

      <Grid item xs={12} md={3} mt={2}>
        {/* =========================== CLIENT DETAILS BOX ================================ */}
        <Box
          sx={{
            border: "1px solid #683C8C",
            position: "relative",
            marginTop: "14px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px 0",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Avatar
              alt={client?.name}
              src="/static/images/avatar/1.jpg"
              sx={{
                width: 58,
                height: 58,
                color: "#fff",
                background: "rgba(104, 60, 140, 0.35)",
              }}
            />
            <Typography sx={{ fontWeight: 600 }}>
              {client?.customerID}
            </Typography>
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#683C8C",
                color: "#FFFFFF",
                borderColor: "#683C8C",
                padding: "2px 60px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#683C8C",
                  color: "#FFFFFF",
                  borderColor: "#683C8C",
                },
              }}
            >
              {client?.name}
            </Button>
          </Box>
        </Box>
        {/* =========================== CLIENT DETAILS BOX ================================ */}

        {/* =======================================  ORDER HISTORY============================================= */}
        <Box
          sx={{
            marginTop: "15px",
            border: "1px solid #683C8C",
            position: "relative",
            padding: "20px",
            marginBottom: "20px",
            height: "600px",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <Typography
            sx={{
              color: "black",
              fontWeight: 600,
              fontSize: "20px",
            }}
          >
            History
          </Typography>

          {/* =================================== ORDER HISTORY BOX ==================================== */}

          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            sx={{ maxWidth: 400 }}
          >
            {mergedSteps.length > 0 ? (
              <Stepper
                activeStep={3}
                orientation="vertical"
                connector={<CustomStepConnector />}
              >
                {mergedSteps.map((step, index) =>
                  step.reason ? (
                    <CustomTooltip
                      key={index}
                      title={step.reason || "No reason provided"}
                      sx={{
                        "& .MuiTooltip-tooltip": {
                          background: "#795898",
                          color: "#fff",
                          fontSize: "8px",
                          padding: "8px",
                        },
                        "& .MuiStep-root:hover .MuiTooltip-tooltip": {
                          background: "red",
                        },
                      }}
                    >
                      <Step>
                        <StepLabel icon={step.icon}>
                          <Typography
                            sx={{
                              color: "rgba(104, 60, 140, 1)",
                              fontSize: "13px",
                              fontWeight: 600,
                            }}
                          >
                            {displyStatus[step.label] || step.label}
                          </Typography>
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: "10px",
                            }}
                          >
                            {step.description}
                          </Typography>
                        </StepLabel>
                      </Step>
                    </CustomTooltip>
                  ) : (
                    <Step>
                      <StepLabel icon={step.icon}>
                        <Typography
                          sx={{
                            color: "rgba(104, 60, 140, 1)",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          {displyStatus[step.label] || step.label}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: "10px",
                          }}
                        >
                          {step.description}
                        </Typography>
                      </StepLabel>
                    </Step>
                  )
                )}
              </Stepper>
            ) : (
              "No History Recorded!"
            )}
          </Box>
        </Box>
        {/* =======================================  ORDER HISTORY============================================= */}
      </Grid>

      <Grid item xs={12} md={9}>
        <Box
          sx={{
            marginTop: "-8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <Box sx={{ marginLeft: "auto" }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                padding: pickup?.status === "Pending" ? "10px" : "7px 38px",
                width: "200px",
                height: "42px",
                textTransform: "capitalize",
                backgroundColor: `${
                  pickup?.status === "Pending"
                    ? "rgba(235, 8, 0, 0.35)"
                    : "#ABE1C5"
                } !important`,
                color: pickup?.status === "Pending" ? "#BE0B0E" : "#074F24",
                border: "1px solid #074F24",
                boxShadow: "none !important",
              }}
            >
              {pickup?.status === "Pending" ? "Not Yet Picked" : "Picked"}
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "219px",
            paddingLeft: "14px",
            marginTop: "15px",
            gap: "10px",
          }}
        >
          <Card
            sx={{
              width: "55%",
              height: "233px",
              borderRadius: "0",
              backgroundColor: "white",
              // overflowY: "scroll",
            }}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              sx={{
                height: "75px",
                background: "rgba(104, 60, 140, 1)",
                padding: "10px 10px",
              }}
            >
              <Typography
                sx={{ color: "#fff", fontSize: "14px", fontWeight: 600 }}
              >
                Client Details & Proof of Purchase Uploaded by Client{" "}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              <Box display={"flex"} alignItems={"center"}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "black",
                    width: "50%",
                  }}
                >
                  {" "}
                  PU Contact / Department{" "}
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", color: "black", width: "50%" }}
                >
                  {" "}
                  {client.name}
                </Typography>
              </Box>
              <Box display={"flex"} alignItems={"center"}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "black",
                    width: "50%",
                  }}
                >
                  {" "}
                  PU Phone Number{" "}
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", color: "black", width: "50%" }}
                >
                  {" "}
                  {client.phone}
                </Typography>
              </Box>
              <Box display={"flex"} alignItems={"center"}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "black",
                    width: "50%",
                  }}
                >
                  {" "}
                  Attachment{" "}
                </Typography>
                <Typography sx={{ width: "50%" }}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    {pickup.pickupEvidenceImage || pickup.image ? (
                      <a href={pickup.pickupEvidenceImage || pickup.image}>
                        <img src={downloadicon} alt="downloadicon" />
                      </a>
                    ) : (
                      <Typography color="red" fontSize="10px">
                        Not Uploaded!
                      </Typography>
                    )}
                  </Box>
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems={"center"}
                justifyContent={"end"}
                position={"relative"}
              >
                {" "}
                {pickup.status === "Completed" && (
                  <PickupProofModal pickup={pickup} />
                )}
              </Box>
            </Box>
          </Card>
          <Card
            sx={{
              width: "55%",
              height: "233px",
              borderRadius: "0",
              backgroundColor: "white",
              // overflowY: "scroll",
            }}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              sx={{
                height: "75px",
                background: "rgba(104, 60, 140, 1)",
                padding: "10px 10px",
              }}
            >
              <Typography
                sx={{ color: "#fff", fontSize: "14px", fontWeight: 600 }}
              >
                Item & $$$
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              <Box display={"flex"} alignItems={"center"}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "black",
                    width: "50%",
                  }}
                >
                  {" "}
                  Item Name
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", color: "black", width: "50%" }}
                >
                  {pickup?.itemName}
                </Typography>
              </Box>
              <Box display={"flex"} alignItems={"center"}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "black",
                    width: "50%",
                  }}
                >
                  Item Category{" "}
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", color: "black", width: "50%" }}
                >
                  {pickup.category?.name}
                </Typography>
              </Box>
              <Box display={"flex"} alignItems={"center"}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "black",
                    width: "50%",
                  }}
                >
                  Entered Item Price{" "}
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", color: "black", width: "50%" }}
                >
                  ${pickup.amount} (Paid by {pickup.paidBy})
                </Typography>
              </Box>
              <Box display={"flex"} alignItems={"center"}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "black",
                    width: "50%",
                  }}
                >
                  Weight
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", color: "black", width: "50%" }}
                >{`${pickup.weight} lbs / ${(pickup.weight * 0.453592).toFixed(
                  2
                )} kg`}</Typography>
              </Box>
            </Box>
          </Card>
        </Box>

        {/* ==================================  ORDER TRACKING BOX======================================== */}
        <Card
          sx={{
            marginLeft: "14px",
            padding: "8px 16px",
            marginBottom: "20px",
            marginTop: "25px",
            height: "465px",
            position: "relative",
            borderRadius: "0",
            backgroundColor: "white",
          }}
        >
          <Typography
            sx={{
              color: "rgba(104, 60, 140, 1)",
              fontSize: "24px",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Pickup Details
          </Typography>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "start",
              alignItems: "flex-start",
              gap: 2,
              height: "180px",
            }}
          >
            <Box
              sx={{
                width: "50%",
                height: "inherit",
              }}
            >
              <PickupMap
                type={"Pickup"}
                address={pickup.pickupaddress}
                position={[pickup.lat, pickup.long]}
              />
            </Box>
            <Box
              sx={{
                width: "50%",
                display: "flex",
                flexDirection: "column",
                gap: "14px",
                maxHeight: "100%",
                overflowY: "auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "rgb(104, 60, 140)",
                    width: "50%",
                  }}
                >
                  Pickup Address :
                </Typography>

                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "rgba(23, 26, 31, 1)",
                    width: "50%",
                    wordWrap: "break-word",
                  }}
                >
                  {pickup.pickupaddress}{" "}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "rgba(104, 60, 140, 1)",
                    width: "50%",
                  }}
                >
                  Company / Store Name :
                </Typography>

                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "rgba(23, 26, 31, 1)",
                    width: "50%",
                  }}
                >
                  {pickup?.store || "NA"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "rgba(104, 60, 140, 1)",
                    width: "50%",
                  }}
                >
                  PU Apt/Unit/Shop No :
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "rgba(23, 26, 31, 1)",
                    width: "50%",
                  }}
                >
                  {pickup?.aptUnitShop || "NA"}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {/* <Box> */}
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "rgba(104, 60, 140, 1)",
                    width: "50%",
                  }}
                >
                  Landmark / <br />
                  Intersection :
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "rgba(23, 26, 31, 1)",
                    width: "50%",
                  }}
                >
                  {pickup?.landmark || "NA"}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              background: "rgba(104, 60, 140, 0.35)",
              padding: "15px",
              height: "80px",
              borderRadius: "12px",
              marginTop: "12px",
            }}
          >
            <Typography
              sx={{ color: "#673C8E", fontSize: "14px", fontWeight: 600 }}
            >
              Pickup Notes from Client
            </Typography>
            <Typography
              sx={{
                color: "#000000",
                fontSize: "14px",
                fontWeight: 400,
                marginTop: "5px",
              }}
            >
              {pickup.clientnote || "NA"}
            </Typography>
          </Box>

          {/* ----------------- DELIVERY BY ------------------- */}
          <Box
            sx={{
              position: "absolute",
              bottom: "20px",
              width: "96%",
              right: "16px",
              left: "16px",
            }}
          >
            <Typography
              sx={{
                color: "rgba(104, 60, 140, 1)",
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              Delivery By
            </Typography>
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                gap: 3,
                justifyContent: "space-between",
              }}
            >
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 2,
                  padding: "13px",
                  width: "205px",
                }}
              >
                <Avatar src={driver?.profile} alt="R" variant="circular" />
                <Box display={"flex"} flexDirection={"column"} gap="3px">
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {pickup?.driverId?.name || order?.driver?.name || "NA"}
                  </Typography>
                  <Typography sx={{ color: "#4F4F4F", fontSize: "12px" }}>
                    {order?.driver?.driverID}
                  </Typography>
                </Box>
              </Card>
              {/* <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}> */}
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  gap: 2,
                  padding: "13px",
                  width: "205px",
                }}
              >
                <IconButton
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid rgba(104, 60, 140, 1)",
                    background: "rgba(104, 60, 140, 0.35)",
                    color: "rgba(104, 60, 140, 1)",
                  }}
                >
                  <PhoneOutlined />
                </IconButton>
                <Box>
                  <Typography sx={{ fontSize: "10px" }}>Telephone</Typography>
                  <Typography sx={{ fontSize: "10px", mt: 1 }}>
                    {pickup.phone}
                  </Typography>
                </Box>
              </Card>
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  gap: 2,
                  padding: "13px",
                  width: "205px",
                }}
              >
                <IconButton
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid rgba(104, 60, 140, 1)",
                    background: "rgba(104, 60, 140, 0.35)",
                    color: "rgba(104, 60, 140, 1)",
                  }}
                >
                  <img src={truck} />
                </IconButton>
                <Box>
                  <Typography sx={{ fontSize: "10px" }}>
                    Expected Pickup Time
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      mt: 1,
                      color:
                        pickup?.date && new Date(pickup?.date) < Date.now()
                          ? "#BE0B0E"
                          : "black",
                    }}
                  >
                    {pickup?.date
                      ? toLocalTime(
                          new Date(pickup?.date),
                          "DD MMM YYYY - h:mm A"
                        )
                      : "Not Available 🚫"}
                  </Typography>
                </Box>
              </Card>
              {/* </Box> */}
            </Box>
          </Box>
        </Card>
        {/* ==================================  ORDER TRACKING BOX======================================== */}
      </Grid>
    </Grid>
  );
}
